import { gql, useQuery } from "@apollo/client";
import { getFetchPolicyOptions } from "api/utils";
import { dateToYYYYMMDD } from "@/utils/date";

export const ADVISOR_LIST_QUERY = gql`
  query GetAdvisors {
    contacts(contactId: "INV%", contactTypeCode: "2", status: "A") {
      id
      contactId
      name
      status
      primaryAddress {
        email
        phone1
      }
    }
  }
`;

export const useGetAdvisors = () => {
  const { loading, error, data, refetch } = useQuery<AdvisorsQuery>(
    ADVISOR_LIST_QUERY,
    {
      ...getFetchPolicyOptions(`useGetAdvisors`),
    }
  );

  return {
    loading: loading,
    error: error,
    data: data,
    refetch,
  };
};

interface AdvisorsQuery {
  contacts: Advisor[];
}

export interface Advisor {
  id: number;
  contactId: string;
  name: string;
  status: string;
  primaryAddress: {
    email: string;
    phone1: string;
  };
}
